
import { Auth } from 'aws-amplify';

const API_BASE_URL = 'https://exh919iy8g.execute-api.eu-north-1.amazonaws.com';

const getAuthHeaders = async () => {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();

    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
    };
};

const requestJson = async (endpoint, payload, method = 'POST') => {
    const requestOptions = {
        method,
        headers: await getAuthHeaders(),
        body: JSON.stringify(payload)
    };

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error calling ${endpoint}:`, error);
        return null;
    }
};

const requestStatus = async (endpoint, payload, method = 'POST') => {
    const requestOptions = {
        method,
        headers: await getAuthHeaders(),
        body: JSON.stringify(payload)
    };

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        console.log(response.status);
        return response.status;
    } catch (error) {
        console.error(`Error calling ${endpoint}:`, error);
        return null;
    }
};

export const getEvaluations = async (groupInfo = {}) => {
    const payload = Object.keys(groupInfo).length
        ? groupInfo
        : {
            arrivalDate: '2023-11-29T03:01:58.000Z',
            groupId: '2C'
        };

    return requestJson('/api/getEvaluations', payload);
};

export const getAllFeedbacksByGroup = async (groupId, instId) => {
    return requestJson('/api/getAllFeedbacksByGroup', { groupId, instId });
};

export const post = async (user) => {
    return requestStatus('/api/userHandlerAdmin', user);
};

export const deleteUser = async (userId) => {
    return requestStatus('/api/deleteUser', { userId }, 'DELETE');
};

export const postEmployee = async (user, requestMethod = 'POST') => {
    return requestStatus('/api/handleUserPool', user, requestMethod);
};

export const requestFeedback = async (feedback, requestMethod = 'POST') => {
    return requestStatus('/api/requestFeedback', feedback, requestMethod);
};

export const getDoorSign = async (userId) => {
    const requestOptions = {


        method: 'POST',
        headers: await getAuthHeaders(),
        body: JSON.stringify({ userId })
    };

    try {
        const response = await fetch(`${API_BASE_URL}/api/getdoorsign`, requestOptions);

        if (response.status === 404) {
            // Door sign hasn't been generated for this user yet - not an error
            return { ok: false, url: null };
        }

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const result = await response.json();

        if (typeof result === 'string' && result.startsWith('https')) {
            return { ok: true, url: result };
        }

        return { ok: false, url: null };
    } catch (error) {
        console.error('Error calling /api/getdoorsign:', error);
        return { ok: false, url: null };
    }
};

export const getUsersByGroup = async (groupId) => {
    return requestJson('/api/getusersbygroup', { groupId });
};

export const getAllUsers = async (instId) => {
    return requestJson('/api/getAllUsers', { instId });
};

export const getAllFromUserPool = async (zoneinfo) => {
    return requestJson('/api/getAllFromUserPool', { zoneinfo });
};

export const getFeedbackByUser = async (userId) => {
    return requestJson('/api/getFeedbackByUser', { userId });
};
